declare global {
  interface Window {
    hj: (...args: unknown[]) => void;
  }
}

// in case hotjar hasn't been initialized yet
window.hj =
  window.hj ||
  ((...args: unknown[]) => {
    // @ts-expect-error - q can't be typed
    (window.hj.q = window.hj.q || []).push(args);
  });

export type HotjarIdentifyData = {
  vin?: string;
  deal_id?: string;
  state?: string;
  temp_info_id?: string;
  lead_status?: string;
  offer_accepted?: boolean;
};

export enum HotjarEvents {
  FlowEntry = 'flow_entry',

  OpenedSigning = 'opened_signing',
  Error = 'error',
  Affiliate = 'affiliate',
  NetworkError = 'network_error',
  ApolloError = 'apollo_error',
  ReactError = 'react_error',
  SecureDataEntry = 'secure_data_entry',
  DownPayment = 'down_payment',
  WeListen = 'we_listen',
  MarketplaceDashboard = 'marketplace_dashboard',
  MarketplaceListingActivated = 'marketplace_listing_activated',
  MarketplaceOfferAccepted = 'marketplace_offer_accepted',
  MarketplaceChecklistCompleted = 'marketplace_checklist_completed',
}

/**
 * @param vin - Only use null if vin is not known yet
 */
const identify = (vin: string | null, data?: HotjarIdentifyData) => {
  window.hj('identify', vin, { vin, ...data });
};

const track = (event: HotjarEvents) => {
  window.hj('event', event);
};

const hotjar = {
  identify,
  track,
};

export default hotjar;
